module.exports = __webpack_public_path__ + "img/tomcat.01014ba0.svg";